const moveTo = (el) => {
    window.scrollTo({
        top: document.getElementById(el).offsetTop,
        left: document.getElementById(el).offsetLeft,
        behavior: 'smooth'
      });
}